            
import { createI18n } from 'vue-i18n'

const messages = {
    en: {
        title: "Tracking Your Claim's Status",
        subtitle: 'Please enter a reference number of your item below.',
        serviceNumber: 'Service Number',
        requestDate: 'Request Date',
        brand: 'Brand',
        partNumber: 'Part Number',
        problemDescription: 'Problem Description',
        contactService: 'Contact Service',
        serviceDetails: 'Service Details',
        claimSubmission: 'Claim Submission',
        receiveGoodsFromCustomer: 'Receive goods from customer',
        deliveryGoodsToVender: 'Delivery goods to vender',
        waitForVendorAnalyzeAndApproval: 'Wait for vendor analyze and approval',
        claimClosed: 'Claim Closed',
        inprogress: 'In progress...',
        service: 'Service',
    },
    th: {
     
        title: "ตรวจสอบสถานะการเคลมสินค้า",
        subtitle: 'ใส่เลขที่งานบริการที่ต้องการค้นหา',
        serviceNumber: 'หมายเลขงานบริการ',
        requestDate: 'วันที่ร้องขอ',
        brand: 'แบรนด์',
        partNumber: 'หมายเลขสินค้า',
        problemDescription: 'รายละเอียดปัญหา',
        contactService: 'หมายเลขติดต่อ',
        serviceDetails: 'รายละเอียดงานบริการ',
        claimSubmission: 'ยื่นเคลม',
        receiveGoodsFromCustomer: 'รับสินค้าจากลูกค้า',
        deliveryGoodsToVender: 'จัดส่งสินค้าไปยังผู้จําหน่าย',
        waitForVendorAnalyzeAndApproval: 'รอผู้จําหน่ายวิเคราะห์และอนุมัติ',
        claimClosed: 'เคลมเสร็จสิ้น', 
        inprogress: 'กําลังดําเนินการ...',
        service: 'หมายเลขบริการ',
    }

}

const i18n = createI18n({
    legacy: true,
    locale: 'th', 
    fallbackLocale: 'en',
    messages,
  })
  
  export default i18n